import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useExport = ({ companyId }: { companyId: string }) => {
  const { mutate: mutateExport, isPending } = useAppMutation([QueryKey.EXPORT_EVENTS, companyId], {
    mutationFn: async () => {
      await ApiService.downloadFile({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'events', 'export'],
      });
    },
  });

  return { mutateExport, isPending };
};
